import React, { FC } from 'react';
import { Dialog } from '../../../../Dialog/Dialog';
import { Button } from '../../../../Button/Button';
import { SaveQuickReport } from '../utils/DataTableQuickReports.types';
import { Typography } from '../../../../Typography/Typography';
import { useIntlUds } from '../../../../../translations/UdsIntlProvider';

interface Props {
  saveQuickReport: SaveQuickReport;
  setSaveQuickReport: (saveQuickReport: SaveQuickReport) => void;
  onDelete: () => void;
}

export const DeleteQuickReportDialog: FC<React.PropsWithChildren<Props>> = ({
  saveQuickReport,
  setSaveQuickReport,
  onDelete
}) => {
  const { intl } = useIntlUds();

  return (
    <Dialog
      dataTest="quick-report-dialog"
      title={intl.DataTable.QuickViews.DeleteQuickReportDialog.title}
      subTitle={intl.DataTable.QuickViews.DeleteQuickReportDialog.message}
      open={typeof saveQuickReport?.name === 'string' && saveQuickReport?.actionType === 'Delete'}
      onClose={() => setSaveQuickReport(undefined)}
      showCancelButton
      showCloseButton
      actions={[
        <Button
          dataTest="quick-report-submit-button"
          key="delete-quick-report"
          variant="contained"
          onClick={onDelete}
          color="secondary"
        >
          {intl.DataTable.QuickViews.DeleteQuickReportDialog.deleteBtn}
        </Button>
      ]}
    >
      <Typography variant="body1Bold">{saveQuickReport?.name}</Typography>
    </Dialog>
  );
};
